import { render, staticRenderFns } from "./csr-card.vue?vue&type=template&id=5ea902af"
import script from "./csr-card.vue?vue&type=script&lang=js"
export * from "./csr-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports